import APIConfiguration from '@savgroup-front-common/configuration/src/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { BaseBackResponse } from '@savgroup-front-common/types';

import apiCall from '../../services/apiCall';

const ENDPOINT = `${APIConfiguration.search}search/favoriteFilter`;

export interface UnsetFilterAsFavoriteCommandArgs {
  filterId: string;
}

async function unsetFilterAsFavoriteCommand(
  args: UnsetFilterAsFavoriteCommandArgs,
): Promise<BaseBackResponse> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.DELETE,
      json: args,
    });

    return response;
  } catch (error: any) {
    return { errors: error?.errors, failure: true } as BaseBackResponse;
  }
}

export default unsetFilterAsFavoriteCommand;
